import _ from 'lodash';
import { createSelector } from 'reselect';
import {
  getBasicRecords,
  getGrowthRecords,
  getMilestoneRecords,
  getDietDiaperRecords,
  getSleepRecords
} from './core';
import { getSelectedBabyId } from './ui';
import { getProfilesById } from './profiles';

// TODO find a way to condense the below since they all do the same thing

const getEnhancedBasicRecords = createSelector(
  getBasicRecords,
  getSelectedBabyId,
  getProfilesById,
  (records, babyId, profiles) =>
    _.chain(records)
      .pickBy(r => r.babyId === babyId)
      .mapValues(r => {
        const provider = profiles[r.providerId];
        return {
          ...r,
          provider: provider ? provider.firstName + ' ' + provider.lastName : r.otherProvider,
          providerId: r.otherProvider ? 'other' : r.providerId
        };
      })
      .value()
);

const getEnhancedGrowthRecords = createSelector(
  getGrowthRecords,
  getSelectedBabyId,
  getProfilesById,
  (records, babyId, profiles) =>
    _.chain(records)
      .pickBy(r => r.babyId === babyId)
      .mapValues(r => {
        const provider = profiles[r.providerId];
        return {
          ...r,
          provider: provider ? provider.firstName + ' ' + provider.lastName : r.otherProvider,
          providerId: r.otherProvider ? 'other' : r.providerId
        };
      })
      .value()
);

const getEnhancedDietDiaperRecords = createSelector(
  getDietDiaperRecords,
  getSelectedBabyId,
  getProfilesById,
  (records, babyId, profiles) =>
    _.chain(records)
      .pickBy(r => r.babyId === babyId)
      .mapValues(r => {
        const provider = profiles[r.providerId];
        return {
          ...r,
          provider: provider ? provider.firstName + ' ' + provider.lastName : r.otherProvider,
          providerId: r.otherProvider ? 'other' : r.providerId
        };
      })
      .value()
);

const getEnhancedMilestoneRecords = createSelector(
  getMilestoneRecords,
  getSelectedBabyId,
  getProfilesById,
  (records, babyId, profiles) =>
    _.chain(records)
      .pickBy(r => r.babyId === babyId)
      .mapValues(r => {
        const provider = profiles[r.providerId];
        return {
          ...r,
          provider: provider ? provider.firstName + ' ' + provider.lastName : r.otherProvider,
          providerId: r.otherProvider ? 'other' : r.providerId
        };
      })
      .value()
);

const getEnhancedSleepRecords = createSelector(
  getSleepRecords,
  getSelectedBabyId,
  getProfilesById,
  (records, babyId, profiles) =>
    _.chain(records)
      .pickBy(r => r.babyId === babyId)
      .mapValues(r => {
        const provider = profiles[r.providerId];
        return {
          ...r,
          provider: provider ? provider.firstName + ' ' + provider.lastName : r.otherProvider,
          providerId: r.otherProvider ? 'other' : r.providerId
        };
      })
      .value()
);

export {
  getEnhancedGrowthRecords,
  getEnhancedDietDiaperRecords,
  getEnhancedMilestoneRecords,
  getEnhancedBasicRecords,
  getEnhancedSleepRecords
};



// WEBPACK FOOTER //
// ./src/selectors/records.js